import React from "react";
import { Typography } from "antd";
import PricingBreadcrumb from "./PricingBreadcrumb";
import TopNavBar from "./TopNavBar";
import CommercialCatalogPlans from "./CommercialCatalogPlans";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

/** /pricing/producers : offres ciblant le profil PRODUCTEUR, servies par le backend commercial. */
const ProducersPricingPlansImproved = () => {
    const navigate = useNavigate();

    return (
        <div style={{ padding: "24px", maxWidth: 1200, margin: "0 auto" }}>
            <TopNavBar />
            <PricingBreadcrumb current="Producteurs" />
            <div style={{ textAlign: "center", marginBottom: 40 }}>
                <Title level={2}>Plans pour Producteurs Agricoles</Title>
                <Paragraph type="secondary">
                    Choisissez le plan le mieux adapté à la taille et aux besoins de votre exploitation.
                </Paragraph>
            </div>
            <CommercialCatalogPlans profile="PRODUCTEUR" accent="#52c41a" onSubscribe={() => navigate("/payment-strip")} />
        </div>
    );
};

export default ProducersPricingPlansImproved;
